<template>
    <div class="top">
        <div class="top-1 flexDiv">
            <div class="logoBox">
                <div class="logo"><a href="./index.html"><img :src="topLogo.Logo" alt="LOGO"></a></div>
                <p class="zhaosheng">人事处<em>国标代码 13100</em></p>
            </div>
            <div class="ssBox">
                <input type="text" class="inputText" placeholder="" v-model='SearchStr' @keyup.enter='Search'/>
                <a href="javascript:;" class="topClick" @click.stop='Search'><img src="../assets/img/ss.png" alt="" ></a>
                <a href="javascript:;" type="button" class="aClickBTN"><img src="../assets/img/menu.png" alt=""></a>
            </div>
        </div>
        <div class="ulDiv">
            <ul class="mulu" id="navBox">
              <li v-for='item in menuListOne' :key='item.ID'>
                <a v-if='item.Url.indexOf("http")==-1' :href="item.Url" class="topA" :class="[item.On?'on':'']">{{item.Name}}</a>
                <router-link v-else :to="(item.Children.length==0?item.Url :item.Children[0].Url)" :key='CId' :class="[item.On?'on':'']" ><i></i> {{item.Name}}</router-link>
                <dl v-if="item.Children.length>0" class="menuDl">
                  <dd v-for="item2 in item.Children" :key="item2.ID">
                    <router-link v-if='item2.Url.indexOf("http")==-1' :to="item2.Url" :key='item2.ID' >{{item2.Name}}</router-link>
                    <a v-else :href="item2.Url">{{item2.Name}}</a>
                  </dd>
                </dl>
              </li>
              <li><a href="http://www.njjku.com/" target="_blank">学院首页</a></li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
	name:'top',
	data(){
		return{
			 menuList:[],
			 menuListOne:[],
			 CId:this.$route.query.CId,
			 SearchStr: null
		}
	},
	methods:{
		Search(){
			if(!this.SearchStr){
				alert('请输入查找关键字');
			}else{
				this.$router.push('./search.html?selText='+this.SearchStr)
			}
		}
	},
	created(){
		this.menuList = this.Base.GetNavColumnsByDid();
		this.menuListOne = this.menuList.filter((ele)=>ele.FID == 0)
		this.menuListOne.forEach((r)=>{
			r.Children = this.menuList.filter((ele)=>ele.FID == r.ID)
		})
		this.menuListOne.unshift({Name:'首页',Url:'./index.html',On: true,Children:[]});
		// console.log(this.menuListOne,1)
    this.topLogo = this.Base.GetOrganInfoByOid(50);
		$(document).ready(function() {
      $('.aClickBTN').on('click',function () {
        $("#navBox").slideToggle("slow");
      });
			$('#navBox>li').on('click',function() {
				$(this).children("dl").stop().slideToggle("slow");
			});
      $('#navBox dd').on('click',function(){
        $("#navBox").fadeOut();
      });
		});
	}
}
</script>

<style lang="less" scoped>
  .top{
      position: sticky;
      top: 0;
      z-index: 100;
      height: 1.4rem;
      background-color: #fafafa;
  }
  .top .logoBox{
      margin-top: 0.14rem;
      margin-left: 0.3rem;
  }
  .top .logo{
      width: 3.93rem;
      height: 0.81rem;
      img{
        object-fit: contain;
      }
  }
  .top .top-1{
      font-size: 0;
  }
  .top .top-1 .zhaosheng{
      font-size: 0.22rem;
      font-weight: bold;
      font-stretch: normal;
      letter-spacing: 0.01rem;
      color: #0069b7;
      margin-left: 0.9rem;
  }
  .zhaosheng em{
      display: inline-block;
      font-size: 0.18rem;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0.01rem;
      margin-left: 0.18rem;
  }
  .ssBox{
      position: relative;
      width: 2.71rem;
  }
  .ssBox input{
      width: 0.84rem;
      height: 0.5rem;
      background-color: #ffffff;
      border-radius: 0.05rem;
      border: solid 0.01rem #333333;
      position: absolute;
      left: 0;
      top: 0.44rem;
      padding: 0 0.46rem 0 0.2rem;
  }
  .ssBox .topClick{
      width: 0.3rem;
      height: 0.3rem;
      display: block;
      position: relative;
      left: 1.13rem;
      top: 0.55rem;
  }
  .top .top-1 a.aClickBTN{
      display: inline-block;
      width: 0.65rem;
      height: 0.48rem;
      float: right;
      z-index: 2;
      font-size: 0;
      position: absolute;
      right: 0.25rem;
      top: 0.46rem;
  }
  .top .daima{
      font-family: SourceHanSansCN-Regular;
      font-size: 0.2rem;
      font-weight: normal;
      font-stretch: normal;
      line-height: 0.25rem;
      letter-spacing: 0.02rem;
      color: #ffffff;
      position: absolute;
      left: 1.1rem;
      bottom: 0.20rem;
  }
  #navBox{
      width: 2.2rem;
      position: absolute;
      top: 1.4rem;
      right: 0.3rem;
      display: none;
      li{
          background-color: #fff;
          text-align: center;
          a{
              font-size: 0.26rem;
              font-weight: normal;
              font-stretch: normal;
              letter-spacing: 0.01rem;
              color: #333;
              display: block;
              line-height: 0.8rem;
          }
          &:hover{
            background-color: #0069b7;
            a.topA{
                color: #fff;
            }
          }
          .on{
              background-color: #0069b7;
              color: #fff;
          }
          .menuDl{
            display: none;
              dd{
                background: #eee;
                a{
                  line-height: 0.6rem;
                }
                &:hover{
                  a{
                    color: #0069b7;
                  }
                }

              }
          }
      }
  }
</style>



// WEBPACK FOOTER //
// src/components/top.vue